import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const NotFoundPage = () => {
    const handleGoBack = () => {
        window.history.back(); 
      };
  return (
    <View style={styles.container}>
      <Text style={styles.text}>404 - Page Not Found</Text>
      <TouchableOpacity style={styles.button} onPress={handleGoBack}>
        <Text style={styles.buttonText}>Go Back</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#4e3e71',
  },
  text: {
    fontSize: 24,
    color: '#FFFFFF',
    marginBottom: 5,
  },
  text: {
    fontSize: 20,
    color: '#FFFFFF',
    marginBottom: 20,
  },
  button: {
    backgroundColor: '#FFFFFF',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  buttonText: {
    color: '#4e3e71',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default NotFoundPage;
